import { __decorate } from "tslib";
// NPM
import { Component, Mixins } from "vue-property-decorator";
//Quinlan
import BaseMixer from "@/router/views/BaseMixer";
import SectionLoader from "@/components/widgets/SectionLoader.vue";
import Loader from "@/components/widgets/loader.vue";
import USMap from "./USMap.vue";
import { DashboardModule } from "@/store/modules/dashboard.module";
let DashBoard = /** @class */ (() => {
    let DashBoard = class DashBoard extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.stateSelected = "States";
        }
        get analystDetail() {
            return DashboardModule.analystDetail;
        }
    };
    DashBoard = __decorate([
        Component({
            name: "AnalystStatisticsComponent",
            components: {
                SectionLoader,
                Loader,
                USMap,
            },
        })
    ], DashBoard);
    return DashBoard;
})();
export default DashBoard;
